<template>
    <div class="timeline-body mt-n4 bg-white">
        <div class="timeline-deco"></div>

       
        <div v-for="t in timeLineList" :key="t.seq" class="timeline-item mt-4">
            <i v-if="t.taskWorkId!=null" class="far fa-check-square bg-pink1-light shadow-l timeline-icon"></i>
            <i v-else-if="t.closeRequestId!=null" class="far fa-times-circle bg-red1-dark shadow-l timeline-icon"></i>
            <i v-else-if="t.taskId!=null" class="far fa-check-circle bg-green1-light shadow-l timeline-icon"></i>

            <div class="timeline-item-content rounded-s" style="background-color: #f0f0f0">
                <p class="text-left mb-0 font-10 ltr">
                    <i class="fa fa-calendar-check text-warning shadow-l mr-1"></i>
                    {{t.logDateTime}}
                </p>
                <p class="mb-0">
                    <i class="fa fa-check-square color-magenta1-light shadow-l ml-2"></i>
                    <span> {{t.typeTitle}}</span>

                </p>
                <p class="mb-1">
                    <i class="fa fa-check-square color-magenta2-light shadow-l ml-2"></i>
                    <b> {{t.title}}</b>
                </p>

                <div v-if="hideDetailsButton!==true">
                <div v-if="t.taskWorkId!=null" class="text-left">
                    <router-link :to="{ name: 'EditTaskWork', params: { taskWorkId: t.taskWorkId  } }">
                        <i class="fa font-14 fa-search rounded-sm shadow-m bg-blue2-dark text-center" style="width:30px;height:30px;line-height:30px"></i>
                    </router-link>
                </div>
                <div v-else-if="t.closeRequestId!=null" class="text-left">
                    <router-link v-if="t.closeRequestId!=$route.params.closeRequestId" :to="{ name: 'CloseTask', params: { closeRequestId: t.closeRequestId  } }">
                        <i class="fa font-14 fa-search rounded-sm shadow-m bg-blue2-light text-center" style="width:30px;height:30px;line-height:30px"></i>
                    </router-link>
                </div>
                <div v-else-if="t.taskId!=null && t.taskFolderId!=$route.params.taskFolderId" class="text-left">
                    <router-link :to="{ name: 'EditTask', params: { taskFolderId: t.taskFolderId,taskId:t.taskId  } }">
                        <i class="fa font-14 fa-search rounded-sm shadow-m bg-blue1-dark text-center" style="width:30px;height:30px;line-height:30px"></i>
                    </router-link>
                </div>
                    </div>
            </div>
        </div>

     
       
      
    </div>
</template>
<script>


    export default {
        props: ['taskId', 'taskFolderId','hideDetailsButton'],
        data() {
            return {
                timeLineList: [],
            };
        },
       
        methods: {
            GetTimeLine() {
                var folderId = this.$route.params.taskFolderId || this.taskFolderId;
                this.$http.get("Task/GetTaskFolderStatusList?taskFolderId=" + folderId)
                   .then(data => {
                        this.timeLineList = data.data;
                    });
            },
        },
        created() {
            this.GetTimeLine();
        }
    };
</script>
<style>
       .modal-mask {
           position: fixed;
           z-index: 9998;
           top: 0;
           left: 0;
           width: 100%;
           height: 100%;
           background-color: rgba(0, 0, 0, 0.5);
           display: table;
           transition: opacity 0.3s ease;
       }

       .modal-wrapper {
           display: table-cell;
           vertical-align: middle;
       }

       .modal-container {
           width: 300px;
           margin: 0px auto;
           background-color: #fff;
           border-radius: 2px;
           box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
           transition: all 0.3s ease;
       }

       .modal-header h3 {
           margin-top: 0;
           color: #42b983;
       }

       .modal-body {
           margin: 20px 0;
           line-height: 1;
       }

       .modal-default-button {
           float: right;
       }


       .modal-enter {
           opacity: 0;
       }

       .modal-leave-active {
           opacity: 0;
       }

           .modal-enter .modal-container,
           .modal-leave-active .modal-container {
               -webkit-transform: scale(2);
               transform: scale(2);
           }
</style>
